import axios from "axios";
import {Keys} from '/src/config.js'

axios.defaults.baseURL = Keys.VUE_APP_API_URL + "/api"; // change this if you want to use a different url for APIs
//axios.defaults.withCredentials = true;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('freshToken');

// Request interceptor to dynamically attach fresh token to every request
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('freshToken');
    if (token && token !== 'null') {
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Response interceptor to properly distinguish 401 (unauthenticated) vs 403 (unauthorized/forbidden)
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error && error.response ? error.response.status : null;
    if (status === 403) {
      console.warn("API 403 Forbidden received:", error.response ? error.response.data : null);
      // DO NOT logout the user on 403! Session is valid, only permission is lacking.
      // If user is on an unauthorized route, redirect safely to their role home.
      try {
        const storedRole = parseInt(localStorage.getItem('user_role') || '0', 10);
        const currentPath = window.location.pathname;
        if (storedRole === 4 && !currentPath.startsWith('/operations')) {
          if (global.vm && global.vm.$router) {
            global.vm.$router.push('/operations').catch(() => {});
          }
        } else if (storedRole === 3 && !currentPath.startsWith('/routes') && !currentPath.startsWith('/trips') && !currentPath.startsWith('/trip-groups')) {
          if (global.vm && global.vm.$router) {
            global.vm.$router.push('/routes').catch(() => {});
          }
        } else if (storedRole === 5 && !currentPath.startsWith('/customer-service')) {
          if (global.vm && global.vm.$router) {
            global.vm.$router.push('/customer-service').catch(() => {});
          }
        }
      } catch (e) {
        console.error("Error in 403 interceptor redirection:", e);
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
